{
  "version": 1,
  "asset_id": "9edaa032-28d1-4d5a-aca7-96262306eb2b",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/9edaa032-28d1-4d5a-aca7-96262306eb2b/g18.jpeg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/9edaa032-28d1-4d5a-aca7-96262306eb2b/g18.jpeg",
  "original_filename": "g18.jpeg",
  "size": 270653,
  "content_type": "image/jpeg",
  "created_at": "2026-07-02T22:52:58Z"
}
